export default __webpack_public_path__ + "static/media/02.d23cf609.jpg";